import { render, staticRenderFns } from "./Accreditation.vue?vue&type=template&id=65ba5fce&scoped=true"
import script from "./Accreditation.vue?vue&type=script&lang=js"
export * from "./Accreditation.vue?vue&type=script&lang=js"
import style0 from "./Accreditation.vue?vue&type=style&index=0&id=65ba5fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ba5fce",
  null
  
)

export default component.exports